import React from "react";

export default function Delimiter(props) {
    return (
        <div className="row">
            <div className="col">
                <hr/>
            </div>
            <div className="col col-auto">{props.text}</div>
            <div className="col">
                <hr/>
            </div>
        </div>
    )
}

